import { __require as t } from "./_Hash.js";
import { __require as h } from "./_ListCache.js";
import { __require as u } from "./_Map.js";
var r, a;
function C() {
  if (a) return r;
  a = 1;
  var e = t(), i = h(), _ = u();
  function s() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (_ || i)(),
      string: new e()
    };
  }
  return r = s, r;
}
export {
  C as __require
};
